export enum SolutionType {
  buyInStoreFicaOnline = 'Buy In store - FICA Online',
  buyOrRentOnlineFicaOnline = 'Buy/Rent Online - FICA Online',
  buyInStoreFicaInstore = 'Buy/Rent Instore - FICA Instore',
  vodacomBusiness = 'Vodacom business',
  thirdPartyOnboarding = '3rd Party',
  vodapay = 'VodaPay',
}
